<main class="agpr-monitoringResult">
    <section
        class="agpr-monitoringResult-mentionSearchResult"
        [attr.aria-label]="'Common.layout.main' | localize"
    >
        <header class="agpr-monitoringResult-heading">
            <h2
                class="agpr-monitoringResult-heading-label"
                [ngClass]="{'agpr-monitoringResult-heading-label--visible': pageHeading}"
            >
                <span *ngIf="pageHeading">{{ pageHeading }}</span>&nbsp;
                <span *ngIf="pageSrHeading" class="u-srOnly">{{ pageSrHeading | localize }}</span>
                <span *ngIf="!pageHeading">{{ 'Monitoring.search.monitoringSearchResults' | localize }}</span>
            </h2>
            <span class="agpr-monitoringResult-heading-divider"></span>
            <agpr-tabs-toggle
                [id]="'mad_tabsToggle'"
                [options]="viewModeOptions"
                [ngModel]="selectedViewMode"
                (ngModelChange)="viewModeChanged($event)"
            ></agpr-tabs-toggle>
        </header>
        <agpr-mention-search-result
            [isSyndicateMode]="selectedViewMode === viewModesEnum.SYNDICATE"
            (outletClicked)="focusOutletTab($event)"
            (contactClicked)="focusContactTab($event)"
            (viewAllSyndicatesClicked)="openSyndicatedMentionsPanel($event)"
        >
            <agpr-message
                *ngIf="subscription?.status === mediaSubscriptionStatusEnum.STAND_BY"
                class="agpr-mentionSearchResult-filtersError agpr-mentionSearchResult-standByWarning"
                [severity]="messageSeverityEnum.warning"
                topMessage
            >
                {{ 'MediaSubscriptions.mediaSubscription.standByWarning.lineOne' | localize }}
                <br>
                    {{ 'MediaSubscriptions.mediaSubscription.standByWarning.lineTwo.beforeLink' | localize }}
                <a
                    routerLink="/Monitoring/subscriptions/dashboard"
                    class="agpr-mentionSearchResult-link"
                >
                    {{ 'MediaSubscriptions.mediaSubscription.standByWarning.lineTwo.linkText' | localize }}
                </a>
                {{ 'MediaSubscriptions.mediaSubscription.standByWarning.lineTwo.afterLink' | localize }}
            </agpr-message>
        </agpr-mention-search-result>
    </section>
    <aside
        class="agpr-monitoringResult-sidebar"
        [attr.aria-label]="'Common.layout.rhp' | localize"
    >
        <button
            *ngIf="showContentToggle && profileCanExpand"
            class="agpr-contentToggle"
            (click)="expandClicked()"
            [attr.aria-label]="'Discover.entityProfile.expand' | localize"
            [agprTooltip]="'Discover.entityProfile.expand'"
        >
            <span
                class="fa-solid fa-circle-chevron-left agpr-contentToggle-toggleIcon"
                aria-hidden="true"
            ></span>
        </button>
        <div
            class="agpr-contentToggle-line"
        ></div>
        <agpr-right-sidebar
            #rhpTabs
            [loading]="isLoading"
            (selectedTabIndexChange)="tabChange($event)"
            (headerIconClicked)="openMentionTakeOver()"
            [ngClass]="{
                'agpr-rightSidebar--stickyTitle': rhpTabs.selectedTab?.id === 'monitoringMention',
                'agpr-rightSidebar--noMention': !focusedMention
            }"
        >
            <agpr-tab
                [id]="'monitoringMention'"
                icon=" fa-file"
                tooltip="Monitoring.results.rhp.mention"
                [headerIcon]="'fa-solid fa-duotone fa-circle-chevron-left'"
                headerIconTooltip="Mention.results.rhp.mentionContent.headerIcon"
            >
                <agpr-mention-information
                    *ngIf="mentions?.length"
                    [id]="'monitoringResult_mentionInformation'"
                    [highlightKeywords]="highlightKeywords"
                    (outletClicked)="focusOutletTab()"
                    (contactClicked)="focusContactTab()"
                    [hasProminenceProvision]="hasProminenceProvision"
                    [showInsights]="focusedMention && !!focusedMention.mentionId"
                ></agpr-mention-information>

                @if (!mentions?.length && !isLoadingMentions && errorType === errorTypes.none) {
                    <agpr-message
                        [id]="'monitoringResult_mentionContent_noContent'"
                        [severity]="messageSeverityEnum.noContent"
                        [useWhiteBg]="true"
                    >
                        <span class="agpr-monitoringResult-noMentionsFound">
                            {{
                                "Monitoring.result.noMentionsAvailable" | localize
                            }}
                        </span>
                    </agpr-message>
                }

                <ng-template #tabFooter>
                    <agpr-action-bar
                        *ngIf="focusedMention && focusedMention.mentionId"
                    >
                        <ng-template #right>
                            <agpr-button
                                label="Monitoring.result.editMention"
                                [style]="buttonTypes.tertiary"
                                id="monitoringResult.editMention"
                                (click)="editSelectedMention()"
                            ></agpr-button>
                        </ng-template>
                    </agpr-action-bar>
                </ng-template>
            </agpr-tab>

            <agpr-mention-insights-explorer-tab
                *ngIf="mieEnabled"
                [id]="'mentionInsightsExplorerTab'"
                icon="fa-kit-duotone fa-agpr-insights"
                tooltip="Monitoring.results.rhp.mentionInsightExplorer"
            ></agpr-mention-insights-explorer-tab>
            <agpr-entity-details-tab
                #contactProfileTab
                [id]="'monitoringRhpTab.contactProfile'"
                icon="fa-user"
                tooltip="Discover.targeting.rhp.tabs.profileMeta"
                [entityType]="entityTypes.CONTACT"
                [syncOutletTabInfo]="false"
                [noContactMessage]="
                    focusedMention?.author.name
                        ? 'Monitor.entityProfile.noAdditionalInfo'
                        : 'Monitor.entityProfile.noContact'
                "
                (canExpand)="handleCanExpandChange($event)"
                (loading)="isLoading = $event"
            ></agpr-entity-details-tab>
            <agpr-entity-details-tab
                #outletProfileTab
                [id]="'monitoringRhpTab.outletProfile'"
                icon="fa-kit-duotone fa-agpr-outlet"
                tooltip="Discover.targeting.rhp.tabs.outletProfileMeta"
                [entityType]="entityTypes.OUTLET"
                [noOutletMessage]="
                    focusedMention?.publication.name
                        ? 'Monitor.entityProfile.noAdditionalInfo'
                        : 'Monitor.entityProfile.noOutlet'
                "
                (canExpand)="handleCanExpandChange($event)"
                (loading)="isLoading = $event"
            ></agpr-entity-details-tab>
            @if (currentRoute.type !== routeTypeEnum.mentions && selectedViewMode !== viewModesEnum.SYNDICATE) {
                <agpr-tab
                    #searchSummaryTab
                    [id]="'monitoringResultcurentRoute'"
                    icon=" fa-file-lines"
                    [showSpacer]="true"
                    [tooltip]="
                        currentRoute.type === routeTypeEnum.topic ? 'Monitoring.results.rhp.summary.topic'
                            : currentRoute.type === routeTypeEnum.folder ? 'Monitoring.results.rhp.summary.folder'
                            : currentRoute.type === routeTypeEnum.subscriptionResults ? 'Monitoring.results.rhp.summary.subscription'
                            : 'Monitoring.results.rhp.summary'
                    "
                >
                    <agpr-monitoring-result-summary
                        [criteria]="mentionSearch"
                    ></agpr-monitoring-result-summary>
                    <ng-template #tabFooter>
                        @if (
                            currentRoute.type === routeTypeEnum.topic ||
                            currentRoute.type === routeTypeEnum.default ||
                            currentRoute.type === routeTypeEnum.results
                        ) {
                            @if (hasAgent) {
                                <agpr-agent-banner
                                    class="agpr-monitoringResult-agentBanner"
                                    id="monitoringResultSummary_agentBanner"
                                    [headerTitle]="'Monitoring.search.agilityAgent.update'"
                                    [placeholder]="'Monitoring.search.prcopilot.updatePlaceholder'"
                                    [(naturalLanguagePrompt)]="naturalLanguagePrompt"
                                    (submit)="onAgentSubmit($event)"
                                ></agpr-agent-banner>
                            } @else {
                                <agpr-agentic-upsell-banner
                                    class="agpr-monitoringResult-agenticUpsell"
                                    id="monitoringResultSummary_agenticUpsell"
                                    heading="Common.agenticUpsell.summary.heading"
                                    message="Common.agenticUpsell.summary.message"
                                ></agpr-agentic-upsell-banner>
                            }
                        }
                    </ng-template>
                </agpr-tab>
            }
            <agpr-tab
                [id]="'monitoringResultsCharts'"
                icon=" fa-pie-chart"
                tooltip="Monitoring.results.rhp.charts"
            >
                <agpr-monitoring-result-charts></agpr-monitoring-result-charts>
            </agpr-tab>
            <agpr-entity-list-tab
                [id]="id + '_monitoringRhpTab_contactList'"
                [entityMode]="entityTypes.CONTACT"
                [hidden]="!hasDiscoverPermission"
                [tooltip]="'Monitoring.results.rhp.contactList.tooltip' | localize"
                (showRhpTakeOver)="openEntityTakeover($event)"
            ></agpr-entity-list-tab>
            <agpr-entity-list-tab
                [id]="id + '_monitoringRhpTab_outletList'"
                [entityMode]="entityTypes.OUTLET"
                [hidden]="!hasDiscoverPermission"
                [tooltip]="'Monitoring.results.rhp.outletList.tooltip' | localize"
                (showRhpTakeOver)="openEntityTakeover($event)"
            ></agpr-entity-list-tab>
            @if ((currentRoute.type === routeTypeEnum.mentions || selectedFolder) &&
                selectedViewMode !== viewModesEnum.SYNDICATE) {
                <agpr-tab
                    [id]="'monitoringResultcreateMentions'"
                    icon=" fa-square-plus"
                    tooltip="Monitoring.results.rhp.createMentions"
                >
                    <agpr-panel header="Monitoring.result.createMention">
                        <div class="u-horizontalAlignRight">
                            <agpr-button
                                [style]="buttonTypes.tertiary"
                                label="Monitoring.result.createMention"
                                [id]="'monitoringResult_createMention'"
                                (click)="createMention()"
                            ></agpr-button>
                        </div>
                    </agpr-panel>
                    <agpr-panel
                        *ngIf="mentionImportTypes?.length > 0"
                        header="Monitoring.result.importMentions"
                    >
                        <div class="u-horizontalAlignRight">
                            <agpr-button
                                [style]="buttonTypes.tertiary"
                                label="Monitoring.result.importMentions"
                                [id]="'monitoringResult_importMention'"
                                (click)="mentionImporterVisible = true"
                            ></agpr-button>
                        </div>
                    </agpr-panel>
                </agpr-tab>
            }
            <agpr-tab
                *ngIf="(hasAdminPermission && currentRoute.type === routeTypeEnum.topic && search)
                || (currentRoute.type === routeTypeEnum.subscriptionResults && subscription?.id && subscription.type === mediaTypesEnum.broadcast)"
                [id]="'monitoringSearchBackfill'"
                icon=" fa-clock-rotate-left"
                tooltip="Monitoring.search.rhp.backfill"
            >
                <agpr-message
                    *ngIf="currentRoute.type === routeTypeEnum.topic"
                    [severity]="messageSeverityEnum.info"
                >
                    {{ 'Monitoring.search.backfill.infoMessage' | localize }}
                </agpr-message>
                <agpr-message
                    *ngIf="currentRoute.type === routeTypeEnum.subscriptionResults"
                    [severity]="messageSeverityEnum.info"
                >
                    {{ 'MediaSubscriptions.backfill.infoMessage' | localize }}
                </agpr-message>
                <agpr-panel
                    header="Monitoring.search.backfill.status"
                >
                    <ng-container *ngFor="let atts of (backfillAttributes$ | async); let last = last">
                        <div class="agpr-monitoringResult-backfillList">
                            <agpr-attribute-list
                                [attributes]="atts"
                            ></agpr-attribute-list>
                        </div>
                        <div
                            *ngIf="!last"
                            class="agpr-monitoringResult-separator"
                        ></div>
                    </ng-container>
                </agpr-panel>
                <ng-template #tabFooter>
                    <agpr-action-bar>
                        <ng-template #right>
                            <agpr-button
                                label="New backfill"
                                [style]="buttonTypes.tertiary"
                                (click)="openBackfillDialog()"
                            ></agpr-button>
                            <agpr-button
                                label="Refresh"
                                [style]="buttonTypes.tertiary"
                                (click)="refreshBackfill()"
                            ></agpr-button>
                        </ng-template>
                    </agpr-action-bar>
                </ng-template>
            </agpr-tab>
        </agpr-right-sidebar>
    </aside>
</main>

<div
    *ngIf="mentionImporterVisible"
    class="agpr-mentionImporter-overlay"
    [@fade]="mentionImporterVisible"
>
    <agpr-mention-importer
        [importMentionFolder]="selectedFolder"
        (hideMentionImporter)="mentionImporterVisible = false"
    ></agpr-mention-importer>
</div>
